module.exports = __webpack_public_path__ + "fonts/remixicon.31d28485.eot";